module.exports = __webpack_public_path__ + "static/heart-tips@2x-18a2cf51e661a880c6cfb0426c3f5540.png";